var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_error",
    d: "M15.375,3.375a12,12,0,1,0,12,12A12,12,0,0,0,15.375,3.375Zm3.04,16.344-3.04-3.04-3.04,3.04a.922.922,0,1,1-1.3-1.3l3.04-3.04-3.04-3.04a.922.922,0,0,1,1.3-1.3l3.04,3.04,3.04-3.04a.922.922,0,0,1,1.3,1.3l-3.04,3.04,3.04,3.04a.926.926,0,0,1,0,1.3A.916.916,0,0,1,18.415,19.719Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#db2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.98aee4b1b7b9790d246cd2320d0d9cb7.svg";
export { ForwardRef as ReactComponent };